<mat-card>{{'productCardsManagment' | translate}}</mat-card>


<div class="container" style="padding: 25px;">

    <mat-grid-list cols="7" rowHeight="50px">
        &nbsp;
        <mat-grid-tile colspan="2">
            <mat-form-field appearance="standard">
                <mat-label>{{'searchByCardNoOrSerial' | translate}}</mat-label>
                <input matInput [(ngModel)]="cardCode">
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
            <button mat-raised-button color="primary" (click)="search()">
                <mat-icon>search</mat-icon>
                {{'filter' | translate}}
            </button>
            &nbsp;
            <button mat-raised-button color="primary" style="background-color: red;" (click)="onDeleteAll()">
                <mat-icon>delete</mat-icon>
                {{'deleteAll' | translate}}
            </button>

        </mat-grid-tile>
    </mat-grid-list>
    <br />

    <mat-grid-list cols="6" rowHeight="50px">

        <mat-grid-tile colspan="1">
            <mat-form-field appearance="standard" class="example-form-field" style="margin: 10px;;">
                <mat-label>{{'category' | translate}}</mat-label>
                <mat-select [(value)]="selectedCategory" (selectionChange)="onCategoryChange()">
                    <mat-option *ngFor="let item of category" [value]="item.id">
                        {{item.arabicName}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="1">
            <mat-form-field appearance="standard" style="margin-right: 5px;">
                <mat-label>{{'directCharged' | translate}}</mat-label>
                <mat-select [(value)]="directCharge" (selectionChange)="onCategoryChange()">
                    <mat-option [value]="true"> {{'yes' | translate}} </mat-option>
                    <mat-option [value]="false"> {{'no' | translate}} </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
            <mat-form-field appearance="standard" class="example-form-field" style="margin: 10px;;">
                <mat-label>{{'subCategory' | translate}}</mat-label>
                <mat-select [(value)]="selectedSubCategory" (selectionChange)="onsubCategoryChange()">
                    <mat-option *ngFor="let item of subCategories" [value]="item.id">
                        {{item.arabicName}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
            <mat-form-field appearance="standard" class="example-form-field" style="margin: 10px;;">
                <mat-label>{{'product' | translate}}</mat-label>
                <mat-select [(value)]="selectedProduct" (selectionChange)="search()">
                    <mat-option *ngFor="let item of products" [value]="item.id">
                        {{item.arabicName}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-grid-tile>




    </mat-grid-list>

    <mat-grid-list cols="6" rowHeight="50px">

        <mat-grid-tile colspan="2">
            <mat-form-field appearance="standard">
                <mat-label>{{'status' | translate}}</mat-label>
                <mat-select [(value)]="selectedStatus" (selectionChange)="statusChange()">
                    <mat-option [value]="-1"> الجميع </mat-option>
                    <mat-option [value]="1"> مباع </mat-option>
                    <mat-option [value]="0"> غير مباع </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
            <mat-form-field appearance="standard" class="example-form-field">
                <mat-label>{{'enterDateRange' | translate}}</mat-label>
                <mat-date-range-input [rangePicker]="rangePicker">
                    <input matStartDate placeholder="Start date" #fromDate>
                    <input matEndDate placeholder="End date" #toDate>
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
                <mat-date-range-picker #rangePicker>
                    <mat-date-range-picker-actions>
                        <button mat-button matDateRangePickerCancel>{{'cancel' | translate}}</button>
                        <button mat-raised-button color="primary" (click)="onDateSearch()"
                            matDateRangePickerApply>{{'filter' | translate}}</button>
                    </mat-date-range-picker-actions>
                </mat-date-range-picker>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
            <mat-form-field appearance="standard">
                <mat-label>{{'filter' | translate}}</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
            </mat-form-field>
        </mat-grid-tile>


    </mat-grid-list>

    <div class="mat-elevation-z8">
        <table mat-table [dataSource]="dataSource" matSort id="productCardTable">

            <ng-container matColumnDef="productName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'product' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.productName}} </td>
            </ng-container>

            <ng-container matColumnDef="CardsNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'cardNo' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.cardNumber}} </td>
            </ng-container>

            <ng-container matColumnDef="serialNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'serialNo' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.serialNumber}} </td>
            </ng-container>

            <ng-container matColumnDef="expiryDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'expiry' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.expiryDate | date: 'dd/MM/yyyy hh:mm a'}} </td>
            </ng-container>

            <ng-container matColumnDef="createDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'createDate' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.createDate}} </td>
            </ng-container>

            <ng-container matColumnDef="addedBy">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'addedBy' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.addedBy}} </td>
            </ng-container>


            <ng-container matColumnDef="info">
                <th mat-header-cell *matHeaderCellDef> {{'info' | translate}} </th>
                <td mat-cell *matCellDef="let row">
                    <button mat-icon-button (click)="info(row)" *ngIf="row.orderdUser != null">
                        <mat-icon>info</mat-icon>
                    </button>
                </td>
            </ng-container>


            <ng-container matColumnDef="edit">
                <th mat-header-cell *matHeaderCellDef> {{'edit' | translate}} </th>
                <td mat-cell *matCellDef="let row">
                    <button mat-icon-button (click)="onEdit(row)">
                        <mat-icon>edit</mat-icon>
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="delete">
                <th mat-header-cell *matHeaderCellDef> {{'delete' | translate}} </th>
                <td mat-cell *matCellDef="let row">
                    <button mat-icon-button (click)="onCancel(row)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">{{'noDataMatchingTheFilter' | translate}}"</td>
            </tr>
        </table>

        <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>

</div>

<ng-template #Modal>

    <h1 mat-dialog-title>{{'confirm' | translate}}</h1>
    <div mat-dialog-content>
        <p>{{'areYouSureToCancel' | translate}}</p>

    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
        <button mat-raised-button color="primary" cdkFocusInitial (click)="confirmCancel()">{{'yes' |
            translate}}</button>
    </div>

</ng-template>

<ng-template #ModalDeleteAll>

    <h1 mat-dialog-title>{{'confirm' | translate}}</h1>
    <div mat-dialog-content>
        <p>سيتم حذف بطاقات عدد </p> {{productCardlst.length}}

    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
        <button mat-raised-button color="primary" cdkFocusInitial (click)="confirmDeleteBulk()">تأكيد الحذف</button>
    </div>

</ng-template>

<ng-template #ModalView>

    <h1 dir="rtl" mat-dialog-title>{{'orderInfo' | translate}}</h1>
    <div dir="rtl" mat-dialog-content>
        <p>{{'product' | translate}} : {{productCardsObj.productName}}</p>
        <p>{{'cardNo' | translate}} : {{productCardsObj.cardNumber}}</p>
        <p>{{'serialNo' | translate}} : {{productCardsObj.serialNumber}}</p>
        <p>{{'expiry' | translate}} : {{productCardsObj.expiryDate | date: 'dd/MM/yyyy hh:mm a'}}</p>
        <p>{{'createDate' | translate}} : {{productCardsObj.createDate}}</p>
        <p>{{'orderdDate' | translate}} : {{productCardsObj.orderdDate}}</p>
        <p>{{'orderdName' | translate}} : {{productCardsObj.orderdUser}}</p>
        <p>{{'orderdPrice' | translate}} : {{productCardsObj.orderdPrice}}</p>
        <p>{{'costPrice' | translate}} : {{productCardsObj.orderdcost}}</p>


    </div>
    <div mat-dialog-actions>
        <button mat-button mat-dialog-close (click)="onNoClick()">Close</button>
    </div>

</ng-template>

<ng-template #ModalEditCard>

    <h1 mat-dialog-title>{{'cardInfo' | translate}}</h1>
    <div mat-dialog-content>

        <mat-form-field appearance="standard">
            <mat-label>{{'cardNo' | translate}}</mat-label>
            <input matInput [(ngModel)]="_cardNo">
        </mat-form-field>

        <mat-form-field appearance="standard">
            <mat-label>{{'serialNo' | translate}}</mat-label>
            <input matInput [(ngModel)]="_serialNo">
        </mat-form-field>

    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
        <button mat-raised-button color="primary" (click)="update()">{{'update' | translate}}</button>
    </div>

</ng-template>

<app-matspinner dir="rtl" [overlay]="spinnerOverlay"></app-matspinner>